/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 職業
 */
export type BaseInfoOccupationEnum =
  (typeof BaseInfoOccupationEnum)[keyof typeof BaseInfoOccupationEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseInfoOccupationEnum = {
  UNEMPLOYED: 'UNEMPLOYED',
  EMPLOYEE: 'EMPLOYEE',
  GOVERNMENT: 'GOVERNMENT',
  NONPROFIT: 'NONPROFIT',
  SELF: 'SELF',
  MEDICAL: 'MEDICAL',
  SERVICE_WORKER: 'SERVICE_WORKER',
  STUDENT: 'STUDENT',
  ELEMENTARY_SCHOOL_STUDENT: 'ELEMENTARY_SCHOOL_STUDENT',
  MIDDLE_SCHOOL_STUDENT: 'MIDDLE_SCHOOL_STUDENT',
  HIGH_SCHOOL_STUDENT: 'HIGH_SCHOOL_STUDENT',
  TECHNICAL_COLLEGE_STUDENT: 'TECHNICAL_COLLEGE_STUDENT',
  JUNIOR_COLLEGE_STUDENT: 'JUNIOR_COLLEGE_STUDENT',
  UNIVERSITY_STUDENT: 'UNIVERSITY_STUDENT',
  VOCATIONAL_SCHOOL_STUDENT: 'VOCATIONAL_SCHOOL_STUDENT',
  FREELANCER: 'FREELANCER',
  MAFF: 'MAFF',
  LABORER: 'LABORER',
  PART_TIME_WORKER: 'PART_TIME_WORKER',
  CHILD: 'CHILD',
  INFANT: 'INFANT',
  HOUSEWIFE: 'HOUSEWIFE',
  HOMEMAKER: 'HOMEMAKER',
  OTHER: 'OTHER',
  UNKNOWN: 'UNKNOWN',
} as const;
